<template>
  <div>
    <img
      src="../../assets/hscs/采集过程/采集过程.png"
      style="width:100vw;min-height:100vh"
      alt
    />
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  width: 100vw;
  height: 100%;
  font-size: 13px;

  background-image: url("../../assets/hscs/采集过程/采集过程.png");
  background-size: contain;
  background-repeat: no-repeat;

  .title {
    margin-top: 120px;
    font-size: 30px;
    font-weight: bold;
  }

  .content {
    margin-top: 16px;
    padding: 25px;
    // height: 700px;
    background-color: #fef2f4;
    border-radius: 10px;
  }
}
</style>